import React, { useState, useEffect, useMemo } from 'react';
import { inject } from 'mobx-react';
import { ChoiceGroup, DefaultButton, mergeStyleSets } from '@fluentui/react';
import moment from 'moment';

import MainLogo from '@v2/components/base/MainLogo';
import { useBrandedLogos } from 'src/brands';
import { getSubscribeLink, getManageLink } from 'src/services/license';
import { ALL_PLANS, Plan } from 'shared/services/license';
import { isTestStage } from 'shared/utils/utils';

import { runShortAction } from 'src/services/utils';


const styles = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    selectors: {
      '& > p': {
        textAlign: 'center',
        marginTop: '8px',
        marginBottom: '0px'
      },
    },
  },

  options: {
    margin: '16px',
  },

  header: {
    textAlign: 'center',
  },

  button: {
    width: '60%',
    margin: '10px auto 0 auto',
  }
});

const PLANS_TO_DISPLAY = ALL_PLANS.filter(x => ![Plan.Trial, Plan.Personal].includes(x)).map(x => ({ key: x, text: x}));

const License = ({ userStore, coachmarkStore }) => {
  const { mainLogo} = useBrandedLogos();
  const { license = {} } = userStore || {};
  const { status = 'canceled', plan_name = 'Invalid plan', valid_through, activation_code } = license.rawLicense;
  const { canChangePlan, hasTrueFreePlan, hasTrueActivePlan, plan, isExpired } = license;
  const [selectedLicenseState, setSelectedLicense] = useState(plan);
  const planToSubscribe = [Plan.Team, Plan.Personal].includes(plan) ? plan : Plan.Admin;
  const openLink = (link) => window.open(link, '_blank');
  
  useEffect(() => runShortAction(async () => {
    await userStore.updateCurrentUser();
  }), []);
  
  const isTest = useMemo(() => isTestStage(STAGE), [STAGE]);

  return (
    <div className={styles.root}>
      <MainLogo logo={mainLogo} />
      
      <p>Plan name: {plan_name}</p>
      <p>License email: {userStore.user.email}</p>
      <p>Subscription ID: {activation_code}{isExpired ? ' (expired)' : ''}</p>
      {/* <p>Last Check: {license.lastCheck.toISOString()}</p> */}
      { !hasTrueFreePlan &&
      <p>Valid Through: {moment(valid_through).format('LL')}</p>}

      { (canChangePlan || isTest) &&   
      (<div className={styles.options}>
        <h4 className={styles.header}>Try different plans</h4>
        <ChoiceGroup
          options={PLANS_TO_DISPLAY}
          required={true}
          selectedKey={selectedLicenseState === Plan.Trial ? Plan.Admin : selectedLicenseState}
          onChange={(_, item) => { userStore.license.plan = item.key; setSelectedLicense(item.key)} }
        />
      </div>) 
      }

      { !hasTrueActivePlan
        ? <DefaultButton className={styles.button}
          text='Subscribe' primary={true}
          onClick={() => openLink(getSubscribeLink(planToSubscribe, activation_code))}
        />
        : <DefaultButton className={styles.button}
          text='Manage subscription' primary={true}
          onClick={() => openLink(getManageLink(activation_code))}
        />
      }
      
    </div>
  );
}

export default inject('userStore', 'coachmarkStore')(License);